import {useEffect, useState} from 'react';

export const METRICS_RANGES = [
	{id: '30m', label: 'Last 30 minutes'},
	{id: '1h', label: 'Last 1 hour'},
	{id: '6h', label: 'Last 6 hours'},
	{id: '24h', label: 'Last 24 hours'},
] as const;

export type MetricsRangeId = (typeof METRICS_RANGES)[number]['id'];

let current: MetricsRangeId = '30m';
const listeners = new Set<() => void>();

export function setMetricsRange(id: MetricsRangeId) {
	current = id;
	listeners.forEach(fn => fn());
}

export function getMetricsRange(): MetricsRangeId {
	return current;
}

export function useMetricsRange(): MetricsRangeId {
	const [range, setRange] = useState(current);
	useEffect(() => {
		const fn = () => setRange(current);
		listeners.add(fn);
		return () => {
			listeners.delete(fn);
		};
	}, []);
	return range;
}
